import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { CartProvider } from './context/CartContext'
import { CatalogProductsProvider } from './context/CatalogProductsContext'
import App from './App.jsx'

// Importamos los estilos CSS en el orden correcto
// Primero globals.css para que las variables estén disponibles
import './styles/globals.css'
// Importamos los colores de la marca VV Health
import './styles/vv-colors.css'
// Luego importamos el resto de estilos
import './index.css'
import './styles/typography.css'
import './styles/fonts.css'
// Importar los overrides de Bootstrap para mantener los colores de la marca
import './styles/bootstrap-overrides.css'

// Import styles for Ant Design
import 'antd/dist/antd.css'

// Comentamos las importaciones de la nueva estructura que aún no están listas
// import './styles/core/variables.css'
// import './styles/core/layout.css'
// import './styles/core/utilities.css'
// import './styles/components/buttons.css'
// import './styles/components/cards.css'
// import './styles/components/forms.css'
// import './styles/components/navigation.css'
// import './styles/components/dashboard.css'

// La gestión de navegación por gestos ahora se realiza a través del componente SwipeNavigation

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <CatalogProductsProvider>
        <CartProvider>
          <App />
        </CartProvider>
      </CatalogProductsProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
